<template>
  <div class="tableWrap">
    <el-table :data="adjustmentList" border size="mini" class="wdb100">
      <el-table-column prop="adjustmentNo" :label="$t('home.supplementalNo')" align="center" width="140px"></el-table-column>
      <el-table-column prop="createTime" :label="$t('home.tradeDate')" align="center" min-width="130px"></el-table-column>
      <el-table-column prop="country" :label="$t('home.supplementalCountry')" align="center" min-width="170px"></el-table-column>
      <el-table-column prop="applyReason" :label="$t('home.description')" align="center" min-width="180px"></el-table-column>
      <el-table-column prop="status" :label="$t('home.supplementalStatus')" align="center" min-width="120px">
        <template slot-scope="scope">
          <p v-if="scope.row.status == 'PASSED'">{{ $t("home.passed") }}</p>
          <p v-if="scope.row.status == 'FORFEITED'">{{ $t("home.forfeited") }}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" :label="$t('notPaid.invoice')" width="132px">
        <template slot-scope="scope">
          <template v-if="scope.row?.customerInvoice?.invoiceNumber">
            <!-- 普通发票 -->
            <template v-if="scope.row?.customerInvoice?.invoiceType == 1">
              <p class="crp blueDark" @click="toLinkInvoice(scope.row.customerInvoice.invoiceNumber)">
                {{ $t("invoice.common.generalInvoice") }}
              </p>
            </template>
            <!-- 退款发票 -->
            <template v-if="scope.row?.customerInvoice?.invoiceType == 2">
              <p class="crp blueDark" @click="toLinkInvoice(scope.row.customerInvoice.invoiceNumber)">
                {{ $t("invoice.common.creditInvoice") }}
              </p>
            </template>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    adjustmentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    // 订单列表/去支付
    toLinkInvoice(invoiceNumber) {
      const { href } = this.$router.resolve({
        path: "/invoice",
        query: {
          invoiceNo: invoiceNumber,
        },
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.tableWrap {
  padding: 10px 20px;
}
</style>
